import { es } from '@/assets/translations'

export const handleSetMoneySign = (countryCode) => {
  for (const country in es) {
    if (country === countryCode) {
      return es[country]['MONEY']
    }
  }
}
